import Swiper from 'swiper'
import { Pagination, Navigation } from 'swiper/modules'

document.addEventListener('DOMContentLoaded', function () {
  const main = document.querySelector('main')
  if (!main || !main.classList.contains('museum-guide')) return

  let shopSwiper = null
  let cafeSwiper = null

  function createShopSwiper() {
    if (shopSwiper) return shopSwiper

    const el = document.querySelector('.museum-guide-swiper-shop')
    if (!el) return null

    shopSwiper = new Swiper(el, {
      modules: [Pagination, Navigation],
      loop: true,
      slidesPerView: 1,
      spaceBetween: 20,
      speed: 600,
      watchOverflow: true,
      pagination: {
        el: '.museum-guide-swiper-pagination-shop',
        clickable: true,
      },
      navigation: {
        nextEl: '.museum-guide-swiper-next-shop',
        prevEl: '.museum-guide-swiper-prev-shop',
      },
    })

    return shopSwiper
  }

  function createCafeSwiper() {
    if (cafeSwiper) return cafeSwiper

    const el = document.querySelector('.museum-guide-swiper-cafe')
    if (!el) return null

    cafeSwiper = new Swiper(el, {
      modules: [Pagination, Navigation],
      loop: true,
      slidesPerView: 1,
      spaceBetween: 20,
      speed: 600,
      watchOverflow: true,
      pagination: {
        el: '.museum-guide-swiper-pagination-cafe',
        clickable: true,
      },
      navigation: {
        nextEl: '.museum-guide-swiper-next-cafe',
        prevEl: '.museum-guide-swiper-prev-cafe',
      },
    })

    return cafeSwiper
  }

  function refreshSwiper(swiper) {
    if (!swiper) return

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        swiper.update()
        swiper.navigation?.update()
        swiper.pagination?.render()
        swiper.pagination?.update()
        swiper.slideTo(0, 0)
      })
    })
  }

  function handleTabSwiper(tabName) {
    if (tabName === 'shop') {
      refreshSwiper(createShopSwiper())
    }

    if (tabName === 'cafe') {
      refreshSwiper(createCafeSwiper())
    }
  }

  document.addEventListener('museum-guideTabChanged', function (e) {
    const tabName = e.detail?.tabName
    handleTabSwiper(tabName)
  })

  const currentContent = document.querySelector('.js_tab_content.is-current[data-tab-content]')
  if (currentContent) {
    handleTabSwiper(currentContent.dataset.tabContent)
  }
})